import EtnersCommonUtil from './etners.common.util'

const codeToText = function (solutionCodeMap, code) {
  if (code == undefined || code == '') {
    return code
  }

  if (solutionCodeMap[code] == undefined) {
    return code
  }
  return solutionCodeMap[code].cdNm
}


// Date 타입 객체를 String으로 format (YYYYMMDD)
const convertDateToStringYYYYMMDDFormat = function (date) {
  if (date == undefined || date == null || !(date instanceof Date)) {
    return date
  }

  const YYYY = date.getFullYear()
  const MM = date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : (date.getMonth() + 1).toString()
  const DD = date.getDate() < 10 ? '0' + date.getDate() : date.getDate().toString()

  return YYYY + MM + DD
}

// Date 타입 객체를 String으로 format (HH)
const convertDateToStringHHFormat = function (date) {
  if (date == undefined || date == null || !(date instanceof Date)) {
    return date
  }

  const HH = date.getHours() < 10 ? '0' + date.getHours() : date.getHours().toString()

  return HH
}

const convertYYYYMMFormat = function (yyyymm) {
  if (yyyymm == undefined || yyyymm == '') {
    return yyyymm
  }

  return yyyymm.substring(0, 4) + '/' + yyyymm.substring(4, 6)
}

const convertYYYYMMDDFormat = function (yyyymmdd) {
  if (yyyymmdd == undefined || yyyymmdd == '') {
    return yyyymmdd
  }

  return yyyymmdd.substring(0, 4) + '/' + yyyymmdd.substring(4, 6) + '/' + yyyymmdd.substring(6, 8)
}

// 대시 기준으로 나눠주기
const convertYYYYMMDDSpaceBar = function (yyyymmdd) {
  if (yyyymmdd == undefined || yyyymmdd == '') {
    return yyyymmdd
  }

  return yyyymmdd.substring(0, 4) + '-' + yyyymmdd.substring(4, 6) + '-' + yyyymmdd.substring(6, 8)
}

const convertYYMMDDFormat = function (yymmdd) {
  if (yymmdd == undefined || yymmdd == '') {
    return yymmdd
  }

  return yymmdd.substring(2, 4) + '/' + yymmdd.substring(4, 6) + '/' + yymmdd.substring(6, 8)
}

const convertHHMIFormat = function (hhmi) {
  if (hhmi == undefined || hhmi == '') {
    return hhmi
  }

  return hhmi.substring(0, 2) + ':' + hhmi.substring(2, 4)
}

const convertYYYYMMDDHHFormat = function (yyyymmddhh) {
  if (yyyymmddhh == undefined || yyyymmddhh == '') {
    return yyyymmddhh
  }
  if (yyyymmddhh.length < 10) {
    return yyyymmddhh
  }

  return yyyymmddhh.substring(0, 4) + '/' + yyyymmddhh.substring(4, 6) + '/' + yyyymmddhh.substring(6, 8) + ' ' + yyyymmddhh.substring(8, 10)
}

const convertYYYYMMDDHHMIFormat = function (yyyymmddhhmi) {
  if (yyyymmddhhmi == undefined || yyyymmddhhmi == '') {
    return yyyymmddhhmi
  }
  if (yyyymmddhhmi.length < 12) {
    return yyyymmddhhmi
  }

  return yyyymmddhhmi.substring(0, 4) + '/' + yyyymmddhhmi.substring(4, 6) + '/' + yyyymmddhhmi.substring(6, 8) + ' ' + yyyymmddhhmi.substring(8, 10) + ':' + yyyymmddhhmi.substring(10, 12)
}

const convertYYYYMMDDHHMISSFormat = function (yyyymmddhhmiss) {
  if (yyyymmddhhmiss == undefined || yyyymmddhhmiss == '') {
    return yyyymmddhhmiss
  }
  if (yyyymmddhhmiss.length < 14) {
    return yyyymmddhhmiss
  }

  return yyyymmddhhmiss.substring(0, 4) + '/' + yyyymmddhhmiss.substring(4, 6) + '/' + yyyymmddhhmiss.substring(6, 8) + ' ' + yyyymmddhhmiss.substring(8, 10) + ':' + yyyymmddhhmiss.substring(10, 12) + ':' + yyyymmddhhmiss.substring(12, 14)
}

// Date 타입 객체를 String으로 format (YYYY/MM/DD HH:MI:SS)
const convertDateToStringYYYYMMDDHHMISSFormat = function(date) {

  if(date == undefined || date == null || !(date instanceof Date)) {

    return date
  }

  let YYYY = date.getFullYear()
  let MM = date.getMonth()+1 < 10 ? "0"+(date.getMonth()+1) : (date.getMonth()+1).toString()
  let DD = date.getDate() < 10 ? "0"+date.getDate() : date.getDate().toString()
  let HH = date.getHours() < 10 ? '0'+date.getHours() : date.getHours().toString()
  let MI = date.getMinutes() < 10 ? '0'+date.getMinutes() : date.getMinutes().toString()
  let SS = date.getSeconds() < 10 ? '0'+date.getSeconds() : date.getSeconds().toString()

  return YYYY+'/'+MM+'/'+DD+' '+HH+':'+MI+':'+SS

}

const categoryCdToText = function (categoryList, code) {
  if (code == undefined || code == '') {
    return code
  }
  let categoryName = code
  let categoryFullName = code
  let topCategoryName = code
  let parentCategoryName = code
  categoryList.forEach(category => {
    if (category.categoryCd === code) {
      categoryName = category.categoryName
      categoryFullName = category.categoryFullName
      topCategoryName = category.topCategoryName
      parentCategoryName = category.parentCategoryName
    } else {
      if (category.items !== undefined) {
        category.items.forEach(item => {
          if (item.categoryCd === code) {
            categoryName = item.categoryName
            categoryFullName = item.categoryFullName
            topCategoryName = item.topCategoryName
            parentCategoryName = item.parentCategoryName
          } else {
            if (item.items !== undefined) {
              item.items.forEach(tDepthCategory => {
                if (tDepthCategory.categoryCd === code) {
                  categoryName = tDepthCategory.categoryName
                  categoryFullName = tDepthCategory.categoryFullName
                  topCategoryName = tDepthCategory.topCategoryName
                  parentCategoryName = tDepthCategory.parentCategoryName
                }
              })
            }
          }
        })
      }
    }
  })
  const returnCategoryArray = { categoryName: categoryName, categoryFullName: categoryFullName, topCategoryName: topCategoryName, parentCategoryName: parentCategoryName }
  return returnCategoryArray
}

const textFindLIkeCode = function (solutionCodeMap, text) {
  if (text == undefined || text == '') {
    return text
  }
  const find = Object.values(solutionCodeMap).find(solution => {
    return solution.cdNm.indexOf(text) !== -1
  })
  if (find === undefined) {
    return text
  }
  return find.cdNameSpace
}

const textFindLIkeCategory = function (categoryMap, text) {
  if (text == undefined || text == '') {
    return code
  }
  let categoryCode = text

  categoryMap.forEach(category => {
    if (category.categoryName.indexOf(text) !== -1) {
      categoryCode = category.categoryCd
    } else {
      if (category.items !== undefined) {
        category.items.forEach(item => {
          if (item.categoryName.indexOf(text) !== -1) {
            categoryCode = item.categoryCd
          } else {
            if (item.items !== undefined) {
              item.items.forEach(tDepthCategory => {
                if (tDepthCategory.categoryName.indexOf(text) !== -1) {
                  categoryCode = tDepthCategory.categoryCd
                }
              })
            }
          }
        })
      }
    }
  })

  return categoryCode
}
const authCodeToText = function (authData, authCd) {
  if (authCd === undefined || authCd === '') {
    return authCd
  }

  const authCorrect = authData.find((auth) => {
    return auth.authCd === authCd
  })

  if (authCorrect == null || authCorrect.length === 0) {
    return authCd
  }
  return authCorrect.authNm
}

const convertCorporateRegNoFormat = function (corporateRegNo) {
  if (corporateRegNo === undefined || corporateRegNo === '') {
    return corporateRegNo
  }
  corporateRegNo = EtnersCommonUtil.extractOnlyNumbers(corporateRegNo)
  return corporateRegNo.replace(/(\d{3})(\d{2})(\d{5})/, '$1-$2-$3')
}

const convertTelNoFormat = function (telNo) {
  if (telNo === undefined || telNo === null || telNo === '') {
    return ''
  }
  if (telNo.includes('-')) {
    return telNo
  }
  if (telNo.length == 9) {
    return telNo.replace(/(\d{2})(\d{3})(\d{4})/, '$1-$2-$3')
  }
  if (telNo.length == 10 && telNo.substring(0, 2) !== '02') {
    return telNo.replace(/(\d{3})(\d{3})(\d{4})/, '$1-$2-$3')
  }
  if (telNo.length == 10 && telNo.substring(0, 2) === '02') {
    return telNo.replace(/(\d{2})(\d{4})(\d{4})/, '$1-$2-$3')
  }
  if (telNo.length == 11) {
    return telNo.replace(/(\d{3})(\d{4})(\d{4})/, '$1-$2-$3')
  }

  return telNo
}

const convertTelNo = function (telNum) {
  if(telNum === undefined || telNum === null){
    return '-'
  }
  const numLen = telNum.length

  let newTelNum = telNum
  switch (numLen) {
      case 8:
        newTelNum = `${telNum.substring(0, 4)}-${telNum.substring(4, 8)}`
        break
      case 9:
        newTelNum = `${telNum.substring(0, 2)}-${telNum.substring(2, 5)}-${telNum.substring(5, 9)}`
        break
      case 10:
        newTelNum = `${telNum.substring(0, 3)}-${telNum.substring(3, 6)}-${telNum.substring(6, 10)}`
        break
      case 11:
        newTelNum = `${telNum.substring(0, 3)}-${telNum.substring(3, 7)}-${telNum.substring(7, 11)}`
        break
      default:
        newTelNum = telNum
    }
    return newTelNum
}


const convertEmptyStringToSeparator = function (text, separator) {

  if (separator === undefined) {
    separator = '-'
  }

  if (EtnersCommonUtil.isEmpty(text)) {
    return separator
  }else {
    return text
  }
}

export default {
  codeToText,
  convertDateToStringYYYYMMDDFormat,
  convertDateToStringHHFormat,
  convertYYYYMMFormat,
  convertYYYYMMDDFormat,
  convertHHMIFormat,
  convertYYYYMMDDHHFormat,
  convertYYMMDDFormat,
  convertYYYYMMDDHHMIFormat,
  convertYYYYMMDDHHMISSFormat,
  convertDateToStringYYYYMMDDHHMISSFormat,
  categoryCdToText,
  textFindLIkeCode,
  textFindLIkeCategory,
  authCodeToText,
  convertCorporateRegNoFormat,
  convertTelNoFormat,
  convertTelNo,
  convertYYYYMMDDSpaceBar,
  convertEmptyStringToSeparator
}
